import React, { useEffect, useRef, useState } from "react"
import * as Yup from "yup"
import SVG from "react-inlinesvg"
import { Form, Formik } from "formik"
import { Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

import { PlantingSessionForm } from "./PlantingSessionForm.jsx"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/index.js"
import { useHtmlClassService, useSubheader } from "../../../../_metronic/layout/index.js"
import { MenuBack } from "../../../../component/atoms/MenuBack/index.jsx"
import { PopupQuestion } from "../../../../component/atoms/Popup/index.jsx"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { AREA_REGISTERED_ENUM, REASON, ROUTING_STATUS } from "../../../../constants/StringConstant.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import {
  FORM_NEED,
  getMaximumErrorString,
  getStringErrorMassage
} from "../../../helpers/StringCollection.js"
import { getListChildReason } from "../../../../redux/actions/ReportActivityAction.jsx"
import {
  bulkConfirmationPlantingSeasonV2,
  confirmationSeasonPlantingV2
} from "../../../../redux/actions/AreaAction.jsx"
import { GeneralSlice } from "../../../../redux/reducers/General.jsx"
import "../../../../_metronic/_assets/sass/pages/error/error-3.scss"
import { AREA } from "../../../../constants/InitTypeConstants.js"
import { getUrlParsingMap } from "../../../../config/EndpointCollection.js"
import { AREA_URL } from "../../../../constants/UrlConstants.js"
import { requestPost } from "../../../../config/index.jsx"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls"

import { Skeleton } from "@material-ui/lab"
import { NoteView } from "../../../../component/index.jsx"

const { actions: general } = GeneralSlice

export const CreatePlantingSessionConfirmation = ({
  history,
  match: {
    params: { id }
  }
}) => {
  const areaIds = id.split(",")
  const location = useLocation()
  const { General } = useSelector((state) => state)

  const queryParams = new URLSearchParams(location.search)
  const tab = queryParams.get("tab")

  let redirectUrl

  switch (tab) {
    case ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.NOT_PAID:
      redirectUrl = ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.NOT_PAID
      break
    case ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.PARTIALLY_PAID:
      redirectUrl = ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.PARTIALLY_PAID
      break
    case ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.PAID:
      redirectUrl = ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.PAID
      break
    default:
      redirectUrl = ROUTING_STATUS.PLANTING_SEASON_STATUS_STRING.NOT_PAID
      break
  }

  const formRef = useRef()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const subHeader = useSubheader()
  const uiService = useHtmlClassService()

  const [showModalConfirmation, setModalConfirmation] = useState(false)
  const [showModalSuccess, setShowModalSuccess] = useState(false)
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [detail, setDetail] = useState([])
  const [loading, setLoading] = useState(false)

  const initialValue = {
    area: areaIds.map(() => ({
      reason_id: null,
      other_reason: null,
      document_url: null,
      document_name: null,
      document_size: null
    }))
  }

  const ValidationScheme = Yup.object().shape({
    area: Yup.array().of(
      Yup.object().shape({
        reason_id: Yup.string().required(
          getStringErrorMassage(
            t("label_reasons_for_confirm_planting_season"),
            FORM_NEED.harusDiIsi
          )
        ),
        other_reason: Yup.string()
          .nullable()
          .when("reason_id", {
            is: REASON.OTHER_PLANTING_SEASON,
            then: (schema) =>
              schema
                .required(
                  getStringErrorMassage(
                    t("label_reasons_for_confirm_planting_season"),
                    FORM_NEED.harusDiIsi
                  )
                )
                .max(100, getMaximumErrorString(100)),
            otherwise: (schema) => schema
          }),
        document_url: Yup.string().required(
          getStringErrorMassage("Dokumen berita acara", FORM_NEED.harusDiIsi)
        ),
        document_name: Yup.string().required(
          getStringErrorMassage("Dokumen berita acara", FORM_NEED.harusDiIsi)
        ),
        document_size: Yup.number().required(
          getStringErrorMassage("Dokumen berita acara", FORM_NEED.harusDiIsi)
        )
      })
    )
  })

  const handleSubmitForm = async () => {
    if (formRef.current) {
      try {
        setDisableSubmit(true)
        await formRef.current.submitForm()
      } catch (error) {
        setDisableSubmit(false)
        setModalConfirmation(false)
        console.error("Form submission error:", error)
      }
    }
  }

  const getData = async (param) => {
    setLoading(true)
    try {
      const res = await requestPost(AREA_URL.GET_LIST_SUBMIT_BA, param)
      setDetail(res.data)
    } catch (error) {
      dispatch(general.setError(error))
    }
    setLoading(false)
  }

  const LoadingSkeleton = () => (
    <Card>
      <CardHeader>
        <Skeleton animation="wave" variant={"text"} width={100} className={"mb-2"} />
        <Skeleton animation="wave" variant={"text"} width={100} className={"mb-2"} />
      </CardHeader>
      <CardBody>
        <Skeleton animation="wave" variant={"text"} width={200} className={"mb-2"} />
        <Skeleton animation="wave" variant={"text"} width={200} className={"mb-2"} />
        <div className={"w-100 position-relative"}>
          <Skeleton animation="wave" variant={"rect"} height={500} />
        </div>
        <Skeleton animation="wave" variant={"text"} width={200} className={"mb-2"} />
        <Skeleton animation="wave" variant={"text"} width={200} className={"mb-2"} />
      </CardBody>
    </Card>
  )

  const header = (
    <div
      className={
        "bg-white d-flex justify-content-between align-items-center p-6 border-1 border-bottom border-bottom-light-dark"
      }>
      <MenuBack
        title={t("send_ba")}
        onClick={() => {
          uiService.setExitFullPage()
          dispatch(
            general.setLoading({
              loading: false,
              actionInitType: null
            })
          )
          history.goBack()
        }}
      />
    </div>
  )

  const modalConfirmation = (
    <PopupQuestion
      show={showModalConfirmation}
      title={t("card_title_planting_session_on_deposit")}
      bodyCustom={
        <div>
          <div className={"text-center"}>
            Dengan mengonfirmasi musim tanam berpiutang,
            <br />
            status musim tanam akan <strong>direset</strong>. <br />
            Pastikan semua data yang diinput telah benar.
          </div>
          <div
            className="w-100 d-flex pt-12"
            style={{ gap: 12 }}
            onClick={() => setModalConfirmation(false)}>
            <Button variant="secondary-info" color="muted" className="w-100">
              {t("button_cancel")}
            </Button>
            <Button className="w-100" onClick={handleSubmitForm}>
              {t("button_next")}
            </Button>
          </div>
        </div>
      }
      isUseFooter={false}
    />
  )

  const modalSuccess = (
    <PopupQuestion
      show={showModalSuccess}
      bodyCustom={
        <div className={"d-flex flex-column align-items-center p-4"}>
          <SVG src={toAbsoluteUrl(ILLUSTRATION_CONSTANTS.POSITIVE_CONFIRM_PLANTING_SEASON)} />
          <span className={"txt-14 mt-8 px-28 text-center"}>
            {areaIds.length === 1
              ? t("messages_response_success_confirm_planting_season")
              : t("messages_response_success_bulk_confirm_planting_season")}
          </span>
          <div className="w-full pt-12">
            <Button
              className="font-weight-bold btn-block my-0 ml-2 fit-content w-100"
              type={"submit"}
              variant={"primary"}
              disabled={false}
              onClick={() => {
                uiService.setExitFullPage()
                dispatch(
                  general.setLoading({
                    loading: false,
                    actionInitType: null
                  })
                )
                {
                  areaIds.length > 1
                    ? history.push(
                        `${RoutesConstants.AREA.LIST_AREA_READY_PLANTING_SEASON_CONFIRMATION(
                          redirectUrl
                        )}?tab=${tab}`
                      )
                    : history.push(
                        RoutesConstants.AREA.DETAIL_AREA(AREA_REGISTERED_ENUM.MT_ACTIVE, id)
                      )
                }
              }}>
              {t("button_oke")}
            </Button>
          </div>
        </div>
      }
      isUseFooter={false}
    />
  )

  const onSubmitForm = async (values) => {
    if (areaIds.length === 1) {
      const payload = values.area[0]
      dispatch(confirmationSeasonPlantingV2(id, payload))
    }

    if (areaIds.length > 1) {
      dispatch(bulkConfirmationPlantingSeasonV2([...values.area]))
    }
  }

  useEffect(() => {
    dispatch(
      getListChildReason(getUrlParsingMap("", "activity_type", "confirm_planting_season"), 0)
    )
    subHeader.setButton(null)
  }, [])

  useEffect(() => {
    uiService.setFullPage()

    return () => {
      uiService.setExitFullPage()
    }
  }, [])

  useEffect(() => {
    getData({ area_ids: areaIds })
  }, [])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (
        General.actionInitType === AREA.BULK_CONFIRMATION_PLANTING_SEASON ||
        General.actionInitType === AREA.PLANTING_SEASON_CONFIRMATION
      ) {
        setModalConfirmation(false)
        setShowModalSuccess(true)
      }
    }

    if (General.loading) {
      setDisableSubmit(true)
    }

    if (!General.loading && General.isError) {
      setDisableSubmit(false)
    }

    setDisableSubmit(false)
  }, [General, General.loading, General.isFinishUpdateOrDelete])

  return (
    <>
      {header}
      {modalConfirmation}
      {modalSuccess}

      <div className="d-flex flex-column-fluid justify-content-center pt-12">
        <div className="w-80vw">
          <NoteView
            variant={"success"}
            title={
              <>
                <div className="pl-6">{t("label_ba_standard_template")}</div>
              </>
            }
            endContent={ 
              <a href={process.env.REACT_APP_BA_TAMPLATE_URL} target="_blank" rel="noreferrer" className="text-secondary-blue underline">
                <span className="font-weight-bolder">{t("label_ba_example")}</span>
              </a>
            }
            customMarginClassName={"mb-0"}
          />
        </div>
      </div>

      {areaIds && areaIds.length > 0 && (
        <div className="d-flex flex-column-fluid justify-content-center pt-10 px-12 pb-12">
          <div className="w-80vw">
            <Formik
              enableReinitialize
              initialValues={initialValue}
              validationSchema={ValidationScheme}
              onSubmit={onSubmitForm}
              innerRef={formRef}
              validateOnChange>
              {({ isValid, dirty, isSubmitting }) => (
                <Form id="form-planting-session" className="form">
                  <>
                    {loading && <LoadingSkeleton />}
                    {detail.map((val, index) => (
                      <PlantingSessionForm
                        key={val.land_id}
                        detail={val}
                        index={index}
                        isBulk={areaIds.length > 1}
                      />
                    ))}
                  </>
                  <div className="d-flex justify-content-end">
                    <Button
                      className="font-weight-bold btn-block my-0 ml-2 fit-content"
                      type="button"
                      variant="primary"
                      disabled={
                        !isValid || !dirty || isSubmitting || disableSubmit || General?.loading
                      }
                      onClick={() => setModalConfirmation(true)}>
                      {t("button_send")}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  )
}
